export default {
    en: {
        answers: 'create a lot of jobs cut jobs',
        interactiveBoxNumber: [1],
        number: 7,
        diagramId: 6,
        blocks:
            [
                {
                    task: {
                        question: 'Market-creating innovations demand capital to grow, but they do create a lot of jobs',
                        answer: '<span class="correct-answer-box correct-answer-box_7">Market-creating innovations demand capital to grow, but they do <span class="highlight__answer highlight__answer_correct">create a lot of jobs</span></span>'
                    },
                    example: true
                },
                {
                    task: {
                        question: 'Efficiency innovations – achieved by cutting the cost of a product or service – usually cut jobs',
                        answer: '<span class="correct-answer-box correct-answer-box_7">Efficiency innovations – achieved by cutting the cost of a product or service – usually <span class="highlight__answer highlight__answer_correct">cut jobs</span></span>'
                    },
                    selectAvailable: true
                },
                {
                    task: {
                        question: 'If companies looked instead to make their product or service more affordable or accessible, they could create net new jobs, not eliminate them',
                        answer: '<span class="correct-answer-box">If companies looked instead to make their product or service more affordable or accessible, they could create net new jobs, not eliminate them</span>'
                    }
                }
            ]
    }
};



// WEBPACK FOOTER //
// ./client/app/modules/courses/3/3a1/deductiveReasoning/i18n/exercise7.js